/* import __COLOCATED_TEMPLATE__ from './prism-menu.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  classNames: ['prism-menu'],
  classNameBindings: ['isOverflow:prism-menu--overflow', 'showContent::prism-menu--insert'],
  isOverflow: false,
  showContent: true,
  close() {}
});